<script lang="ts">
  import UserEmail from "@modern/components/retailer/SpecsOnboarding/UserEmail.svelte";
  import UserForm from "@modern/components/retailer/SpecsOnboarding/UserForm.svelte";
  import { Http } from "@shared/svelte/Modules/ApiService";

  export let accountNumber: string;
  export let initializationVector: string;

  let email = "";
  let showUserForm = false;

  const onUserCreated = () => {
    Http(
      {
        method: "POST",
        url: "/api/onboarding/specs_retailer",
        data: { account_number: accountNumber, initialization_vector: initializationVector },
      },
      function (_res: any) {
        window.location.href = "/users/sign_in";
      },
      function (_res: any) {
        window.location.href = "/users/sign_in";
      }
    );
  };

  const setEmail = (enteredEmail: string) => {
    email = enteredEmail;
    showUserForm = true;
  };

</script>

{#if showUserForm}
  <UserForm {email} {onUserCreated} />
{:else}
  <UserEmail onValidEmailEntered={setEmail} />
{/if}
